/* Common code that is used in the order summary section of Checkout and Confirmation */

export const orderSummaryMixin = {
  props: {
    menuData: Array,
  },
  computed: {
    restaurantMenu() {
      return this.menuData || this.$store.getters.restaurantMenu
    },
  },
  methods: {
    getMenuItem(menuId) {
      if (!this.restaurantMenu) {
        return null
      }

      const menuItems = this.restaurantMenu.filter((item) => item.id === menuId)

      return menuItems.length ? menuItems[0] : null
    },
    getTagline(menuId) {
      const menuItem = this.getMenuItem(menuId)

      return menuItem && menuItem.tagline ? menuItem.tagline : ''
    },
  },
}
